import * as React from "react";
import { cn } from "../../lib/utils";

export type TextAreaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex w-full rounded-[8px] border border-input bg-white text-black px-[14px] py-[10px] text-base focus-visible:outline-none  disabled:cursor-not-allowed disabled:bg-disable2 disabled:hover:border-gray7 focus:shadow-none focus-visible:shadow-none resize-none border-input file:border-0 file:bg-transparent file:text-sm file:font-medium focus:bg-lightYellow2 focus:shadow-none focus-visible:shadow-none placeholder:text-placeHolder placeholder:text-opacity-55 placeholder:text-base disabled:text-disable focus:shadow-shadow1",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
TextArea.displayName = "TextArea";

export { TextArea };
